import React, { Component } from 'react'

class HeaderTitle extends Component {
    static defaultProps = {
        className: '',
        title: 'wrong title'
    }

    state = {
        animationClass: ''
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                animationClass: 'header-title--active'
            })
        }, 200)
    }

    render() {
        return (
            <h1 className={`header-title header1 ${this.props.className} ${this.state.animationClass}`}>{this.props.title}</h1>
        )
    }
}

export default HeaderTitle



// WEBPACK FOOTER //
// ./src/scripts/components/HeaderTitle.jsx